import styled, { css } from "styled-components";
import { hexToRGB } from "@shared/utils/misc";

export const focusRing = css`
  &:focus-visible {
    outline: 2px solid ${(p) => p.theme.colors.primaryBlue};
    outline-offset: 2px;
  }
`;

export const selectableCard = css`
  box-sizing: border-box;
  border: 1px solid ${(p) => p.theme.colors.cardBorderColor};
  border-radius: ${(p) => p.theme.radii.control + 4}px;
  background: ${(p) => p.theme.colors.cardBgColor};
  cursor: pointer;
  transition: border-color 150ms ease, box-shadow 150ms ease,
    background-color 150ms ease;
  &:hover {
    border-color: ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.45)};
    box-shadow: ${(p) => p.theme.shadows.dashboardCard};
  }
  ${focusRing};
`;

export const SectionLabel = styled.div`
  color: ${(p) => p.theme.colors.titleColor};
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
`;

export const Hint = styled.div`
  color: ${(p) => p.theme.colors.secondaryText};
  font-size: 12.5px;
  line-height: 18px;
`;

export const LogoTile = styled.span<{ $size?: number }>`
  flex: none;
  display: inline-grid;
  place-items: center;
  width: ${(p) => p.$size ?? 40}px;
  height: ${(p) => p.$size ?? 40}px;
  /* The logo on its own: no tile around it (the logos carry their own
     shape and colour). */
  img,
  svg {
    display: block;
  }
`;

export const TextDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${(p) => p.theme.colors.secondaryText};
  font-size: 12.5px;
  line-height: 18px;
  white-space: nowrap;
  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: ${(p) => p.theme.colors.cardBorderColor};
  }
`;
